import { createFileRoute } from "@tanstack/react-router";
import AdminDemoSetDefaultPage from "@/pages/admin/demos/sets/default";
import { useDemosPermissions } from "@/pages/admin/demos";

export const Route = createFileRoute("/app/admin/demos/sets/default")({
  component: RouteComponent,
});

function RouteComponent() {
  const {
    userCanViewAllSets,
    userCanEditAllSetDemos,
    userCanViewAllSetDemos,
  } = useDemosPermissions();

  return (
    <AdminDemoSetDefaultPage
      userCanViewAllSets={userCanViewAllSets}
      userCanEditAllSetDemos={userCanEditAllSetDemos}
      userCanViewAllSetDemos={userCanViewAllSetDemos}
    />
  );
}
